import * as React from "react";
import ChooseGame from "../components/ChooseGame/ChooseGame";

const HomePage = () => {
    return (
        <ChooseGame />
    );
}

export default HomePage;
